import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bookAppointmentAction, getClinicsAction } from "../../redux/actions/appointmentActions";
import Button from "../../components/Button/Button";
import TopBar from "../../components/TopBar";
import axios from "axios";
import Loading from "../../components/Loading";
import { check_token, pushNotification } from "../../utils";
import { toast } from "react-toastify";
import { 
  FaHospital, 
  FaCalendarAlt, 
  FaClock, 
  FaStethoscope, 
  FaStickyNote,
  FaMapMarkerAlt,
  FaUserMd
} from "react-icons/fa";
export default function FirstAppointment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const store = useSelector((state) => state.bookAppontment);
  const clinicStore = useSelector((state) => state.getClinicsAction);
  const { loading, success, error, data } = store;
  const user = JSON.parse(localStorage.getItem("userInfo"));

  const [state, setState] = React.useState({
    appt_date: "",
    appt_time: "",
    clinic_name: "",
    clinic_id: "",
    notes: "",
    patient: user.id,
    location: user.location,
    appt_type: 'hospital',
    appt_mode: 'hospital',
  });
  const handleChange = (e) => {
    if (e.target.name === "clinic") {
      setState({ ...state, clinic_name: e.target.options[e.target.selectedIndex].text, clinic_id: e.target.value })
      return;
    }
    setState({ ...state, [e.target.name]: e.target.value });

  };

  const msg = (text) => {
    toast.warning(text, {
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state.clinic_name === "") {
      msg("Please select a clinic");
      return;
    }
    if (state.appt_date === "") {
      msg("Please choose an appointment date");
      return;
    }
    if (state.appt_time === "") {
      msg("Please choose an appointment time");
      return;
    }
    dispatch(bookAppointmentAction(state));
  };

  // Effect for initial data loading
  useEffect(() => {
    check_token();
    dispatch(getClinicsAction());
  }, [dispatch]);

  // Effect for handling booking success/error
  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: "BOOK_APPOINTMENT_RESET" });
    }

    if (success) {
      // pushNotification('You have successfully booked an appointment');
      dispatch({ type: "BOOK_APPOINTMENT_RESET" });
      dispatch({ type: "GET_APPOINTMENT_RESET" });
      navigate("/appointment-booked", { state: { data: state } });
    }
  }, [success, error, dispatch, navigate, state])

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50">
      <TopBar title={"Appointment"} url={"/homedashboard"} />
      
      {/* Tab Navigation */}
      <div className="px-4 pt-6 pb-4">
        <div className="flex bg-white rounded-xl shadow-lg p-2 max-w-md mx-auto">
          <div className="flex-1">
            <Button
              text={"Hospital"}
              textColor={"text-white"}
              bg={"bg-primary100"}
              width={"full"}
            />
          </div>
          <div className="flex-1 ml-2">
            <Link to={"/appointment-online"}>
              <Button 
                text={"Online"} 
                width={"full"} 
                bg={"bg-gray-100"} 
                textColor={"text-gray-600"}
              />
            </Link>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="px-4 mb-6">
        <div className="bg-gradient-to-r from-primary100 to-blue-600 rounded-2xl p-6 text-white shadow-xl">
          <div className="flex items-center mb-3">
            <div className="bg-white/20 rounded-full p-3 mr-4">
              <FaHospital className="text-2xl" />
            </div>
            <div>
              <h2 className="text-xl font-bold">Hospital Visit</h2>
              <p className="text-blue-100">Book an in-person appointment</p>
            </div>
          </div>
          <p className="text-blue-100 leading-relaxed">
            Schedule your visit to meet with our healthcare professionals at the hospital facility.
          </p>
        </div>
      </div>

      {/* Form Container */}
      <div className="px-4 pb-24">
        <div className="bg-white rounded-2xl shadow-xl p-6 space-y-6">
          
          {/* Clinic Selection */}
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="bg-primary100/10 rounded-full p-2">
                <FaStethoscope className="text-primary100 text-lg" />
              </div>
              <label className="text-lg font-semibold text-gray-800">Select Clinic</label>
            </div>
            <div className="relative">
              <select
                className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-primary100 focus:bg-white transition-all duration-200 appearance-none"
                name="clinic"
                onChange={handleChange}
              >
                <option value="">Choose your preferred clinic</option>
                {clinicStore?.loading ? (
                  <option value="">Loading clinics...</option>
                ) : clinicStore?.error ? (
                  <option value="">Error loading clinics. Please refresh.</option>
                ) : clinicStore?.data?.data?.length > 0 ? (
                  clinicStore.data.data.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                  ))
                ) : (
                  <option value="">No clinics available</option>
                )}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>

          {/* Date and Time Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* Date Selection */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="bg-green-100 rounded-full p-2">
                  <FaCalendarAlt className="text-green-600 text-lg" />
                </div>
                <label className="text-lg font-semibold text-gray-800">Appointment Date</label>
              </div>
              <div className="relative">
                <input
                  type="date"
                  className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-green-500 focus:bg-white transition-all duration-200"
                  name="appt_date"
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>
            </div>

            {/* Time Selection */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="bg-blue-100 rounded-full p-2">
                  <FaClock className="text-blue-600 text-lg" />
                </div>
                <label className="text-lg font-semibold text-gray-800">Appointment Time</label>
              </div>
              <div className="relative">
                <input
                  type="time"
                  name="appt_time"
                  onChange={handleChange}
                  className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-blue-500 focus:bg-white transition-all duration-200"
                />
              </div>
            </div>
          </div>

          {/* Notes Section */}
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="bg-purple-100 rounded-full p-2">
                <FaStickyNote className="text-purple-600 text-lg" />
              </div>
              <label htmlFor="notes" className="text-lg font-semibold text-gray-800">
                Additional Notes
              </label>
            </div>
            <textarea
              rows={4}
              name="notes"
              onChange={handleChange}
              id="notes"
              className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-purple-500 focus:bg-white transition-all duration-200 resize-none"
              placeholder="Tell us about your symptoms or any specific concerns..."
            />
          </div>

          {/* Submit Button */}
          <div className="pt-4">
            {loading ? (
              <div className="flex justify-center py-4">
                <Loading />
              </div>
            ) : (
              <button 
                className="w-full bg-gradient-to-r from-primary100 to-blue-600 hover:from-primary100/90 hover:to-blue-600/90 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center space-x-2"
                onClick={handleSubmit}
              >
                <FaUserMd className="text-lg" />
                <span className="text-lg">Book Hospital Appointment</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
